import { render, staticRenderFns } from "./DisableCampaign.vue?vue&type=template&id=6cbbcad4&scoped=true&"
import script from "./DisableCampaign.vue?vue&type=script&lang=ts&"
export * from "./DisableCampaign.vue?vue&type=script&lang=ts&"
import style0 from "./DisableCampaign.vue?vue&type=style&index=0&id=6cbbcad4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbbcad4",
  null
  
)

export default component.exports